import { FC, useState, useEffect } from "react";
import { TrajetType, PecType } from "data/types";
import EvenementBtns2 from "components/EvenementBtns2";
import EvenementBtns3 from "components/EvenementBtns3";
import { useTranslation } from 'react-i18next';

export interface CardTrajetIntegreProps {
  className?: string;
  author: TrajetType;
  index: string;
  listePecPlanificateur?: PecType[];
  selected?: boolean;
  isMap?: boolean;
  onLocalisationClick?: (type: String) => void;
  symbole_monnaie: string;
  numDroit: number;
}

const CardTrajetIntegre: FC<CardTrajetIntegreProps> = ({
  className = "",
  author,
  index,
  listePecPlanificateur,
  selected,
  isMap,
  onLocalisationClick,
  symbole_monnaie,
  numDroit
}) => {
  const { t } = useTranslation();

  const { displayName, libelle2, prix, paiement, type, debut, fin, compagnie, ref, location, moment, duree, distance, lat, longi, lat2, longi2, simplifie } = author;
  const [lienVisible, setLienVisible] = useState("");
  const [lienItineraire, setLienItineraire] = useState("");
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [isSimplifie, setIsSimplifie] = useState(simplifie);

  const isRestitutionLocation = location === "O" && moment === "R";

  const isLocation = location === "O";
const isPriseEnCharge = isLocation && moment === "P";
const isRestitution = isLocation && moment === "R";

const hasTransportDetails =
  distance !== "" ||
  duree !== "" ||
  compagnie !== "" ||
  ref !== "";

const hasDureeDistance = duree !== "" || distance !== "";
const hasCompagnieRef = compagnie !== "" || ref !== "";

const hasDepart = displayName !== "" || debut !== "";
const hasArrivee = libelle2 !== "" || fin !== "";

const showTimeline = location !== "O" && ((!isSimplifie && (hasDepart || hasArrivee)) || (isSimplifie && (debut || fin || duree || distance || ref || compagnie)));

const showStartPoint = location !== "O" && hasDepart;
const showEndPoint = location !== "O" && hasArrivee;

const hasBlocTransport =
  hasTransportDetails;

const needsDepartArriveeSpacing =
  showStartPoint &&
  showEndPoint &&
  !hasTransportDetails &&
  location !== "O";

const arrivalSpacingClass = !showStartPoint && showEndPoint
  ? "pt-4"
  : needsDepartArriveeSpacing
  ? "pt-7"
  : "pt-1";

  useEffect(() => {
    //gestion lien lien_modifie si createur ou visiteur et etat=R pour créateur géré par l'api
    if(author.lien !== undefined && author.lien !== "" && numDroit ===1)
    {
      setLienVisible(author.lien);
    }
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien ==="V")
    {
      setLienVisible(author.lien);
    } 
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien === "M" && author.lien_modifie !== undefined && author.lien_modifie !== "")
    {
      setLienVisible(author.lien_modifie);
    }
 
    if(author.lat !== "" && author.longi !== "" && author.lat2 !== "" && author.longi2 !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir/"+author.lat+","+author.longi+"/"+author.lat2+","+author.longi2+"/");
    }
    else if(author.lat !== "" && author.longi !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat+","+author.longi+"/");
    }
    else if(author.lat2 !== "" && author.longi2 !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat2+","+author.longi2+"/");
    }

  }, []);

  const afficheOptions = () => {
    setShowOptions(true);
  }

  const cacheOptions = () => {
    setShowOptions(false);
  }

  return ( <>
        { isSimplifie ? (
            <div onMouseOver={afficheOptions}
          onMouseLeave={cacheOptions}
          className="relative curseurPointeur"
          >
            {showTimeline && (
              <div
                className="
                  grid
                  grid-cols-[12px_42px_minmax(0,1fr)]
                  grid-rows-[auto_1fr_auto]
                  gap-x-1
                  min-h-[46px]
                  items-center
                "
              >
                {/* Point de départ */}
                <div className="relative col-start-1 row-start-1 flex justify-center self-center">
                  {showStartPoint && (
                    <span
                      className="
                        relative
                        z-10
                        block
                        h-[7px]
                        w-[7px]
                        min-h-[7px]
                        min-w-[7px]
                        rounded-full
                        border-2
                        border-green-500
                        bg-white
                        dark:bg-neutral-900
                      "
                    />
                  )}
                </div>

                {/* Heure de départ, à droite du point et centrée verticalement */}
                <div className="col-start-2 row-start-1 flex items-center">
                  {debut !== "" && (
                    <span className="whitespace-nowrap text-xxs font-semibold leading-none text-neutral-500 dark:text-neutral-400">
                      {debut}
                    </span>
                  )}
                </div>

                {/* Trait vertical */}
                {showStartPoint && showEndPoint && (
                  <div className="relative col-start-1 row-start-2 flex h-full justify-center">
                    <span
                      className="
                        absolute
                        inset-y-0
                        left-1/2
                        w-[1px]
                        -translate-x-1/2
                        bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
                        dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
                      "
                    />
                  </div>
                )}

                {/* Point d'arrivée */}
                <div className="relative col-start-1 row-start-3 flex justify-center self-center">
                  {showEndPoint && (
                    <span
                      className="
                        relative
                        z-10
                        block
                        h-[7px]
                        w-[7px]
                        min-h-[7px]
                        min-w-[7px]
                        rounded-full
                        border-2
                        border-green-500
                        bg-white
                        dark:bg-neutral-900
                      "
                    />
                  )}
                </div>

                {/* Heure d'arrivée, à droite du point et centrée verticalement */}
                <div className="col-start-2 row-start-3 flex items-center">
                  {fin !== "" && (
                    <span className="whitespace-nowrap text-xxs font-semibold leading-none text-neutral-500 dark:text-neutral-400">
                      {fin}
                    </span>
                  )}
                </div>

                {/* Bloc transport simplifié : compagnie, référence, durée et distance */}
                <div className="col-start-3 row-span-3 min-w-0 self-center">
                  {hasTransportDetails && (
                    <div
                      className="
                        my-2
                        rounded-2xl
                        border
                        border-neutral-100
                        bg-neutral-50
                        px-1.5
                        py-1.5
                        dark:border-neutral-700
                        dark:bg-neutral-800/70
                      "
                    >
                      <div
                        className="
                          flex
                          items-center
                          gap-1
                          text-[10px]
                          text-neutral-600
                          dark:text-neutral-300
                        "
                      >
                        {hasCompagnieRef && (
                          <div className="flex min-w-0 flex-1 items-center">
                            <div
                              className={`
                                min-w-0
                                w-full
                                leading-tight
                                ${hasDureeDistance ? "text-right" : "text-center"}
                              `}
                            >
                              {compagnie !== "" && (
                                <div className="truncate text-xxs font-semibold text-neutral-900 dark:text-white">
                                  {compagnie}
                                </div>
                              )}

                              {ref !== "" && (
                                <div className="truncate text-xxs text-neutral-500 dark:text-neutral-400">
                                  {ref}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {hasCompagnieRef && hasDureeDistance && (
                          <div className="h-7 w-px flex-shrink-0 bg-neutral-200 dark:bg-neutral-700" />
                        )}

                        {hasDureeDistance && (
                          <div
                            className={`
                              flex
                              flex-col
                              justify-center
                              leading-tight
                              ${
                                hasCompagnieRef
                                  ? "flex-shrink-0 items-start text-left"
                                  : "flex-1 items-center text-center"
                              }
                            `}
                          >
                            {duree !== "" && (
                              <div
                                className={`
                                  flex
                                  items-center
                                  gap-0
                                  ${hasCompagnieRef ? "" : "w-full justify-center"}
                                `}
                              >
                                <i className="las la-clock mr-0.5 text-xs text-neutral-500" />
                                <span className="no-slider-margin whitespace-nowrap text-xxs">
                                  {duree}
                                </span>
                              </div>
                            )}

                            {distance !== "" && (
                              <div
                                className={`
                                  flex
                                  items-center
                                  gap-0
                                  ${hasCompagnieRef ? "" : "w-full justify-center"}
                                `}
                                data-tooltip-id="myTooltip"
                                data-tooltip-content="Estimation à vol d'oiseau ou selon le mode de transport si la durée est affichée"
                                data-tooltip-place="bottom"
                              >
                                <i className="las la-ruler-combined mr-0.5 text-xs text-neutral-500" />
                                <span className="no-slider-margin whitespace-nowrap text-xxs">
                                  {distance} km
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
                <div className="">
                        { (author.bloc !== "" || author.document !== "" || lienVisible || lienItineraire) && (
                 <EvenementBtns3 optionsVisibles={false}  className = "right-3 top-2 w-4 h-4"
              lienVisible={lienVisible}  lienItineraire={lienItineraire} index={index || '' }/>
            )}
            </div>
            </div>
        )
        :
        (
    <div
      
      className={`
  ${selected ? "selectedCard" : ""}

  nc-CardTrajetIntegre
  group
  relative
  w-full

  flex
  flex-col
  items-center
  justify-center
  text-center

  rounded-[30px]
  overflow-visible

  bg-[linear-gradient(145deg,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.94)_55%,rgba(248,250,252,0.96)_100%)]
  dark:bg-neutral-900

  border
  border-white/80
  dark:border-neutral-800

  shadow-[0_14px_32px_rgba(15,23,42,0.10),inset_0_1px_0_rgba(255,255,255,0.95)]
  hover:shadow-[0_18px_40px_rgba(15,23,42,0.14),inset_0_1px_0_rgba(255,255,255,0.95)]

  px-2
  py-3

  transition-all
  duration-300
  ease-out
  hover:-translate-y-[2px]

  ${showOptions ? "z-[9999]" : "z-1"}

  ${className}
`}
      data-nc-id="CardTrajetIntegre"
      onMouseOver={afficheOptions}
      onMouseLeave={cacheOptions}
    >
      {/* couche visuelle de la card, clipsée aux coins */}
<div
  className="
    pointer-events-none
    absolute
    inset-0
    rounded-[30px]
    overflow-hidden
  "
>
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.95)_0%,transparent_38%),radial-gradient(circle_at_100%_100%,rgba(241,245,249,0.75)_0%,transparent_42%)]
    "
  />

  <div
    className="
      absolute
      inset-[1px]
      rounded-[29px]
      border
      border-white/80
    "
  />

  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      shadow-[inset_0_-10px_22px_rgba(15,23,42,0.035)]
    "
  />
</div>

        { (author.bloc !== "" || author.document !== "" || lienVisible || lienItineraire) && (
             <EvenementBtns2 optionsVisibles={false}  className = "right-3 top-2 w-4 h-4"
              lienVisible={lienVisible}  lienItineraire={lienItineraire} index={index || '' }/>
        )}
<div
  className={`
    relative
    z-10
    w-full

    mt-2
  `}
>

</div>
{/* CONTENU TRAJET NOUVEAU VISUEL, FORMAT INTÉGRÉ */}
<div
  className="
    relative
    z-10
    w-full
    grid
    grid-cols-[14px_minmax(0,1fr)]
    gap-x-0
    text-left
  "
>
  {/* POINT DÉPART */}
  {showTimeline && (
    <div className="relative z-10 flex justify-center pt-1">
      {showStartPoint && (
        <span
          className="
            relative
            z-10
            block
            flex-none
            w-[7px]
            h-[7px]
            min-w-[7px]
            min-h-[7px]
            rounded-full
            border-2
            border-green-500
            bg-white
            dark:bg-neutral-900
          "
        />
      )}

      {/* Même logique que CardTrajet : le trait existe aussi si seul le départ est saisi */}
      {showStartPoint && (
        <span
          className={`
            absolute
            top-[13px]
            w-[1px]

            ${
              showEndPoint || hasTransportDetails
                ? needsDepartArriveeSpacing
                  ? "-bottom-7"
                  : "-bottom-3"
                : "bottom-0"
            }

            bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
            dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
          `}
        />
      )}
    </div>
  )}

  {/* DÉPART */}
  <div className={`${location === "O" ? "col-span-2" : ""} min-w-0`}>
    {(debut !== "" || displayName !== "") && (
    <div
  className={`
    ${debut === "" ? "block" : "grid grid-cols-[20px_minmax(0,1fr)] gap-2 items-start"}
  `}
>
  {debut !== "" && (
    <div className="relative top-[2px] text-xxs font-semibold text-neutral-500 leading-snug">
      {debut}
    </div>
  )}

  <div className="min-w-0">
          {displayName !== "" && (
            <h2
               className={`${(location === "O" && debut === "") ? "text-center" : ""} text-xxs
                font-semibold
                text-neutral-900
                dark:text-white
                leading-snug
                break-words`}
            >
              {displayName}

              {isMap && displayName !== "" && (lat === "" || longi === "") && (
                <>
                  {" "}
                  <i
                    className="las la-location-arrow text-rose-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("coordonneesGPSAbsentes")}
                    data-tooltip-place="top"
                    onClick={
                      numDroit === 1 || numDroit === 0
                        ? () =>
                            alert(
                              "Pour placer ce lieu, veuillez passer en mode modification."
                            )
                        : undefined
                    }
                  />
                </>
              )}

              {isMap && displayName !== "" && lat !== "" && longi !== "" && (
                <>
                  {" "}
                  <i
                    className="curseurPointeur las la-location-arrow text-green-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("cliquezCarte")}
                    data-tooltip-place="top"
                    onClick={() =>
                      onLocalisationClick && onLocalisationClick("depart")
                    }
                  />
                </>
              )}
            </h2>
          )}
        </div>
      </div>
    )}
  </div>

  {/* LIGNE TRANSPORT */}
  {hasTransportDetails && (
    <>
      <div className="relative flex justify-center">
        {showTimeline && (
          <span
            className="
              absolute
              -top-3
              -bottom-3
              w-[1px]
              bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
              dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
            "
          />
        )}
      </div>

      <div className={`${location === "O" ? "col-span-2" : ""} min-w-0`}>
        <div
          className="
            my-2
            rounded-2xl
            bg-neutral-50
            dark:bg-neutral-800/70
            border
            border-neutral-100
            dark:border-neutral-700
            px-1.5
            py-1.5
          "
        >
          <div
            className="
              flex
              items-center
              gap-0.5
              text-[10px]
              text-neutral-600
              dark:text-neutral-300
            "
          >
            {hasCompagnieRef && (
              <div className="flex items-center min-w-0 flex-1">
                <div
                  className={`
                    min-w-0
                    w-full
                    leading-tight
                    ${hasDureeDistance ? "text-right" : "text-center"}
                  `}
                >
                  {compagnie !== "" && (
                    <div className="text-xxs font-semibold text-neutral-900 dark:text-white truncate">
                      {compagnie}
                    </div>
                  )}
                </div>
              </div>
            )}

            {hasCompagnieRef && hasDureeDistance && (
              <div className="h-7 w-px bg-neutral-200 dark:bg-neutral-700 flex-shrink-0" />
            )}

            {hasDureeDistance && (
              <div
                className={`
                  flex
                  flex-col
                  justify-center
                  leading-tight
                  ${
                    hasCompagnieRef
                      ? "items-start flex-shrink-0 text-left"
                      : "items-center flex-1 text-center"
                  }
                `}
              >
                {duree !== "" && (
                  <div
                    className={`
                      flex
                      items-center
                      gap-0
                      ${hasCompagnieRef ? "" : "justify-center w-full"}
                    `}
                  >
                    <span className="no-slider-margin whitespace-nowrap text-xxs">
                      {duree}
                    </span>
                  </div>
                )}

                {distance !== "" && (
                  <div
                    className={`
                      flex
                      items-center
                      gap-0
                      ${hasCompagnieRef ? "" : "justify-center w-full"}
                    `}
                    data-tooltip-id="myTooltip"
                    data-tooltip-content="Estimation à vol d'oiseau ou selon le mode de transport si la durée est affichée"
                    data-tooltip-place="bottom"
                  >
                    <span className="no-slider-margin whitespace-nowrap text-xxs">
                      {distance} km
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )}

  {/* POINT ARRIVÉE — logique reprise de CardTrajet */}
  {showTimeline && (
    <div
      className={`
        relative
        flex
        justify-center

        ${
          !showStartPoint && showEndPoint
            ? "pt-4"
            : needsDepartArriveeSpacing
            ? "pt-7"
            : "pt-1"
        }
      `}
    >
      {showEndPoint && (
        <span
          className={`
            absolute
            w-[1px]

            ${
              !showStartPoint
                ? "top-0 h-4"
                : needsDepartArriveeSpacing
                ? "top-[4px]"
                : isMap
                ? "-top-3 bottom-[10px]"
                : "-top-3 top-[4px]"
            }

            bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
            dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
          `}
        />
      )}

      {showEndPoint && (
        <span
          className="
            relative
            top-[3px]
            z-10
            block
            flex-none
            w-[7px]
            h-[7px]
            min-w-[7px]
            min-h-[7px]
            rounded-full
            border-2
            border-green-500
            bg-white
            dark:bg-neutral-900
          "
        />
      )}
    </div>
  )}

{/* ARRIVÉE */}
<div
  className={`
    ${location === "O" ? "col-span-2" : ""}
    min-w-0

    ${
      !showStartPoint && showEndPoint
        ? "pt-4"
        : needsDepartArriveeSpacing
        ? "pt-7"
        : ""
    }
  `}
>
    {(fin !== "" || libelle2 !== "") && (
<div
  className={`
    ${
      fin === ""
        ? "block w-full"
        : "grid grid-cols-[20px_minmax(0,1fr)] gap-2 items-start"
    }
  `}
>
  {fin !== "" && (
    <div className="relative top-[2px] text-xxs font-semibold text-neutral-500 dark:text-neutral-400 leading-snug">
      {fin}
    </div>
  )}

<div className="min-w-0">
  {libelle2 !== "" && (
  <h2
  className={`
    text-xxs
    font-semibold
    text-neutral-900
    dark:text-white
    leading-snug
    break-words
    ${isRestitutionLocation ? "text-center" : "text-left"}
  `}
>
              {libelle2}

              {isMap && libelle2 !== "" && (lat2 === "" || longi2 === "") && (
                <>
                  {" "}
                  <i
                    className="las la-location-arrow text-rose-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("coordonneesGPSAbsentes")}
                    data-tooltip-place="top"
                    onClick={
                      numDroit === 1 || numDroit === 0
                        ? () =>
                            alert(
                              "Pour placer ce lieu, veuillez passer en mode modification."
                            )
                        : undefined
                    }
                  />
                </>
              )}

              {isMap && libelle2 !== "" && lat2 !== "" && longi2 !== "" && (
                <>
                  {" "}
                  <i
                    className="curseurPointeur las la-location-arrow text-green-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("cliquezCarte")}
                    data-tooltip-place="top"
                    onClick={() =>
                      onLocalisationClick && onLocalisationClick("arrivee")
                    }
                  />
                </>
              )}
            </h2>
          )}
        </div>
      </div>
    )}
  </div>
</div>
   {!isMap && prix !== "" && Number(prix) !== 0 ? (
  <div
    className={`
      relative
      z-10
      w-full

      ${isLocation ? "mt-2" : "mt-2"}

      pt-1

      border-t
      border-neutral-100
      dark:border-neutral-800

      flex
      items-center
      justify-center

      text-xxs

      text-neutral-900
      dark:text-white
    `}
  >
    <span className="whitespace-nowrap">
      {prix} {symbole_monnaie}
    </span>
  </div>
) : null}

    {listePecPlanificateur && location === "O" && index && moment === "R" && listePecPlanificateur.map((pec, pecIndex) => (
      <div className="text-xxs relative z-10" key={`pec-${pecIndex}`}>
        {pec.rattachement === index.split('-')[1] && (
          <span>
          
          Début de location : {pec.date_journee.split(" ")[1]}
          {pec.debut !== "" && ` à ${pec.debut}`}</span>
        )}
      </div>
    ))}
    </div>
 )}
  </>
  );
};

export default CardTrajetIntegre;
